// extracted by mini-css-extract-plugin
module.exports =  {"root":"SCPrgQ4iAQ3fYpg1Jtsm","horizontal":"AZbfQbtpJcl_SJibEigL","vertical":"MeTEd8ArQv43BX_9pxZO","indented":"_IE7Ac6MRfM66bHjx6mm"};